import { Box, Typography } from "@mui/material";
import {
	CarrierChangeData,
	PassChangeData,
} from "../../../models/ShiftReportResponse";
import { CarrierChangesTable } from "./CarrierChangesTable";
import { PassChangesTable } from "./PassChangesTable";

type Props = {
	uninstalledCarriers: CarrierChangeData[];
	installedCarriers: CarrierChangeData[];
	passChanges: PassChangeData[];
};

export const TableRollChanges = ({
	uninstalledCarriers,
	installedCarriers,
	passChanges,
}: Props) => {
	const hasUninstalled = uninstalledCarriers && uninstalledCarriers.length > 0;
	const hasInstalled = installedCarriers && installedCarriers.length > 0;
	const hasPassChanges = passChanges && passChanges.length > 0;

	if (!hasUninstalled && !hasInstalled && !hasPassChanges) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				height="100%"
				minHeight={100}
			>
				<Typography color="text.secondary" variant="body2">
					No roll changes during this shift
				</Typography>
			</Box>
		);
	}

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
			<CarrierChangesTable
				uninstalledCarriers={uninstalledCarriers || []}
				installedCarriers={installedCarriers || []}
			/>

			<PassChangesTable passChanges={passChanges || []} />
		</Box>
	);
};
